
	import { Component } from 'vue-property-decorator';
	import Vue from 'vue';
	@Component({
		name: 'PrivacyPage'
	})
	export default class PrivacyPage extends Vue {
		back() {
			this.$router.go(-1);
		}
	}
